import { PropsWithChildren, ReactNode } from "react";
import { Link } from "react-router-dom";
import { useStore } from "../../hooks/use-store/useStore";
import { StatusMessage } from "../status-message/statusMessage";
import { useLocalization } from "../../hooks/use-localization/useLocalization";

interface Props extends PropsWithChildren {
  title?: string;
  showLoginLink?: boolean;
}

export const Page: React.FC<Props> = ({ title, showLoginLink, children }) => {
  const { localizeString, localize } = useLocalization();
  const store = useStore();
  const app = store.app;

  if (!app) {
    return (
      <div className="page">
        <div className="banner" />
        <div className="content">
          <div className="card">
            <h1>App er ikke valgt</h1>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page">
      <div
        className="banner"
        style={
          app.backgroundImage
            ? { backgroundImage: `url(${app.backgroundImage})` }
            : undefined
        }
      />
      <div className="content">
        <div className="card">
          {app.logo && (
            <img
              className="logo"
              src={app.logo}
              alt={`Logo for ${app.label || app.name}`}
            />
          )}
          {title && <h1>{title}</h1>}
          {store.error && (
            <StatusMessage type="error">
              {localizeString(store.error)}
            </StatusMessage>
          )}
          {children}
        </div>
        {showLoginLink && (
          <Link className="button tertiary" to={`/${app.name}/logg-inn`}>
            {"< "}
            {localize("backToLogin")}
          </Link>
        )}
      </div>
    </div>
  );
};
